<span class="tag-status" [ngClass]="{ archived: !tag.isActive }">
  <span>{{ (tag.isActive ? "active" : "archived") | localize }}</span>
</span>
